import ConsultationService from "../../Services/ConsultationService";
import LabOrderService from "../../Services/LabOrderService";
import PatientService from "../../Services/PatientService";

export const FETCH_PATIENTS_REQUEST = "FETCH_PATIENTS_REQUEST";
export const FETCH_PATIENTS_SUCCESS = "FETCH_PATIENTS_SUCCESS";
export const FETCH_PATIENTS_FAILURE = "FETCH_PATIENTS_FAILURE";

export const FETCH_PATIENTS_COUNT_REQUEST = "FETCH_PATIENTS_COUNT_REQUEST";
export const FETCH_PATIENTS_COUNT_SUCCESS = "FETCH_PATIENTS_COUNT_SUCCESS";
export const FETCH_PATIENTS_COUNT_FAILURE = "FETCH_PATIENTS_COUNT_FAILURE";

export const FETCH_PATIENTPRESCRLIST_REQUEST =
  "FETCH_PATIENTPRESCRLIST_REQUEST";
export const FETCH_PATIENTPRESCRLIST_SUCCESS =
  "FETCH_PATIENTPRESCRLIST_SUCCESS";
export const FETCH_PATIENTPRESCRLIST_FAILURE =
  "FETCH_PATIENTPRESCRLIST_FAILURE";

export const FETCH_PATIENTLABTESTSLIST_REQUEST =
  "FETCH_PATIENTLABTESTSLIST_REQUEST";
export const FETCH_PATIENTLABTESTSLIST_SUCCESS =
  "FETCH_PATIENTLABTESTSLIST_SUCCESS";
export const FETCH_PATIENTLABTESTSLIST_FAILURE =
  "FETCH_PATIENTLABTESTSLIST_FAILURE";

export const SET_SELECTED_PATIENT = "SET_SELECTED_PATIENT";
export const CLEAR_SELECTED_PATIENT = "CLEAR_SELECTED_PATIENT";

export const SET_SELECTEDEDIT_PATIENT = "SET_SELECTEDEDIT_PATIENT";
export const CLEAR_SELECTEDEDIT_PATIENT = "CLEAR_SELECTEDEDIT_PATIENT";

export const SET_PATIENTREGISTRATION_PAYLOAD =
  "SET_PATIENTREGISTRATION_PAYLOAD";
export const CLEAR_PATIENTREGISTRATION_PAYLOAD =
  "CLEAR_PATIENTREGISTRATION_PAYLOAD";

export const PATIENT_FILTER_ENABLED = "PATIENT_FILTER_ENABLED";
export const PATIENT_FILTER_CLEAR = "PATIENT_FILTER_CLEAR";

export const fetchPatients = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PATIENTS_REQUEST });
  try {
    const response = await PatientService.PatientList(payload);
    dispatch({ type: FETCH_PATIENTS_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PATIENTS_FAILURE, payload: error.message });
  }
};

export const fetchPatientsCount = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PATIENTS_COUNT_REQUEST });

  try {
    const response = await PatientService.PatientCount(payload);
    dispatch({
      type: FETCH_PATIENTS_COUNT_SUCCESS,
      payload: response.data.TOTAL_COUNT_STATUS,
    });
  } catch (error) {
    dispatch({ type: FETCH_PATIENTS_COUNT_FAILURE, payload: error.message });
  }
};

export const fetchPatientPrescriptions = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PATIENTPRESCRLIST_REQUEST });
  try {
    const response = await ConsultationService.getPrescriptions(payload);
    dispatch({ type: FETCH_PATIENTPRESCRLIST_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_PATIENTPRESCRLIST_FAILURE, payload: error.message });
  }
};

export const fetchPatientLabTests = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_PATIENTLABTESTSLIST_REQUEST });
  try {
    const response = await LabOrderService.getLabReportsData(payload);
    dispatch({
      type: FETCH_PATIENTLABTESTSLIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_PATIENTLABTESTSLIST_FAILURE,
      payload: error.message,
    });
  }
};

export const setSelectedPatient = (patient) => ({
  type: SET_SELECTED_PATIENT,
  payload: patient,
});

export const clearSelectedPatient = (patient) => ({
  type: CLEAR_SELECTED_PATIENT,
  payload: patient,
});

export const handleSetPatientRegistrationPayload = (patient) => ({
  type: SET_PATIENTREGISTRATION_PAYLOAD,
  payload: patient,
});

export const handleClearPatientRegistrationPayload = (patient) => ({
  type: CLEAR_PATIENTREGISTRATION_PAYLOAD,
  payload: patient,
});

export const setSelectedEditPatient = (patient) => ({
  type: SET_SELECTEDEDIT_PATIENT,
  payload: patient,
});

export const clearSelectedEditPatient = (patient) => ({
  type: CLEAR_SELECTEDEDIT_PATIENT,
  payload: patient,
});

export const setPatientFilter = (state) => ({
  type: PATIENT_FILTER_ENABLED,
  payload: state,
});

export const clearPatientFilter = (state) => ({
  type: PATIENT_FILTER_CLEAR,
  payload: state,
});
